import { Checkbox } from '@percent/lemonade'

import type { OpportunityFormTimeLogsAreRewardsEligibleCheckboxProps } from './opportunity-form-time-logs-are-rewards-eligible-checkbox.types'

export function OpportunityFormTimeLogsAreRewardsEligibleCheckbox({
  value,
  onChange,
  label,
  description,
}: Readonly<OpportunityFormTimeLogsAreRewardsEligibleCheckboxProps>) {
  return (
    <Checkbox
      name="timeLogsAreRewardsEligible"
      value={value ? 'true' : undefined}
      active={value}
      onChange={(e) => onChange(e.currentTarget.checked)}
      label={label}
      helperText={description}
      variant="default"
    />
  )
}
